<template>
  <slot />

  <div class="space-y-24">
    <Delivery
      :items
      :last-collection-point
      :show-error="hasCollectionPointError"
      @updated="
        () => {
          emit('update', () => {
            hasCollectionPointError = false
            isUpdating = false
          })
        }
      "
      @updating="isUpdating = true"
    />

    <div class="flex justify-end">
      <RevButton
        :disabled="loading || isUpdating"
        full-width="adaptive"
        :loading="loading || isUpdating"
        type="submit"
        variant="primary"
        @click="handleSubmit"
      >
        {{ i18n(translations.submitButton) }}
      </RevButton>
    </div>
  </div>
</template>

<script setup lang="ts">
import { ref } from 'vue'

import type { ApiSpecs } from '@backmarket/nuxt-module-http-v2/specs'
import { useI18n } from '@backmarket/nuxt-module-i18n/useI18n'
import { RevButton } from '@ds/components/Button'

import Delivery from '~/scopes/checkout/components/Delivery/Delivery.vue'
import { hasCollectionPointAddressCompleted } from '~/scopes/checkout/utils/hasCollectionPointAddressCompleted'
import { hasCollectionPointOptionSelected } from '~/scopes/checkout/utils/hasCollectionPointOptionSelected'

import translations from './DeliveryRecap.translations'

const props = defineProps<{
  items: ApiSpecs['/bm/cart']['GET']['response']['cartItems']
  lastCollectionPoint?: ApiSpecs['/bm/cart']['GET']['response']['lastCollectionPoint']
  loading: boolean
}>()

const isUpdating = ref(false)
const hasCollectionPointError = ref(false)
const i18n = useI18n()

const emit = defineEmits(['submit', 'update'])

function handleSubmit() {
  // Check if user selected collection point option as delivery option
  // but did not choose which collection point they want to deliver to
  if (
    hasCollectionPointOptionSelected(props.items) &&
    !hasCollectionPointAddressCompleted(props.lastCollectionPoint)
  ) {
    hasCollectionPointError.value = true

    return
  }

  emit('submit')
}
</script>
